var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "el-container",
    [
      _c(
        "el-aside",
        { staticStyle: { "margin-top": "20px" }, attrs: { width: "120px" } },
        [
          _c("sidebar", {
            staticClass: "sidebar-container",
            on: { retParentMenu: _vm.byChildByParent },
          }),
        ],
        1
      ),
      _vm._v(" "),
      _c(
        "el-container",
        [
          !_vm.isInIframe
            ? _c(
                "el-header",
                { staticClass: "header" },
                [
                  _c("navbar", {
                    attrs: { nameshow: _vm.nameshow },
                    on: { helpcenterEvent: _vm.showhelp },
                  }),
                ],
                1
              )
            : _vm._e(),
          _vm._v(" "),
          _c("el-main", { style: _vm.isInIframe ? "margin-top: 0" : "" }, [
            _c(
              "div",
              {
                staticClass: "main-container",
                class: { hasTagsView: _vm.needTagsView },
              },
              [
                _c("div", { class: { "fixed-header": _vm.fixedHeader } }, [
                  _c(
                    "div",
                    { staticClass: "left_main" },
                    [
                      _vm.currRouter
                        ? _c("SubSidebar", {
                            staticClass: "sidebar-container1",
                            attrs: { currRouterData: _vm.currRouter },
                          })
                        : _vm._e(),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          class: _vm.currRouter ? "min_width" : "max_width",
                          attrs: { id: "main_work" },
                        },
                        [
                          _vm.needTagsView
                            ? _c("tags-view", {
                                on: { retParentMenu: _vm.byChildByParent },
                              })
                            : _vm._e(),
                          _vm._v(" "),
                          _c("app-main"),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.showhelped === "true",
                              expression: "showhelped === 'true'",
                            },
                          ],
                          staticClass: "helpcenter",
                        },
                        [_c("help-word")],
                        1
                      ),
                    ],
                    1
                  ),
                ]),
                _vm._v(" "),
                _vm.showSettings
                  ? _c("right-panel", [_c("settings")], 1)
                  : _vm._e(),
              ],
              1
            ),
          ]),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }